import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orprocedures',
  templateUrl: './orprocedures.component.html',
  styleUrls: ['./orprocedures.component.css']
})
export class OrproceduresComponent implements OnInit {
  activetab = 0;
  constructor() { }

  ngOnInit() {
  }

}
